import { useRouter } from 'next/router';
import { useOTSTranslation } from 'i18n/useOTSTranslation';
import { ReactComponent as SvgDeal } from 'public/assets/icons/deal.svg';
import { Button } from 'components/blocks/Button';

import { Routes } from 'routes';
import { IResortShortReport } from 'api/region/types';
import { hasWeSkiIntegration } from 'components/common/PlanYourTrip/WeSki/resolver';
import { RESORT_IDS_TO_HIDE_LODGING_FOR } from 'ots-constants';
import { getLocale } from 'i18n/locale';
import { isResortWithoutWeSki } from 'util/isResortWithoutWeSki';
import styles from './styles.module.scss';

interface IProps {
  resort: IResortShortReport;
}

const ToLodgingRedirectButton = ({ resort }: IProps) => {
  const { t } = useOTSTranslation('common');
  const router = useRouter();
  const locale = getLocale();

  if (RESORT_IDS_TO_HIDE_LODGING_FOR.includes(resort.uuid)) {
    return null;
  }

  const hasWeSki = hasWeSkiIntegration({ resortId: resort.uuid });
  const shouldHideWeSki = isResortWithoutWeSki(resort.uuid, locale, resort.uuid !== '592' && true);
  const useWeSkiRoute = hasWeSki && !shouldHideWeSki;

  if (!useWeSkiRoute) {
    return null;
  }

  const onButtonClick = () => {
    router.push(Routes.resortBookTrip(resort));
  };

  return (
    <Button className={styles.redirectButton} onClick={onButtonClick}>
      <SvgDeal />
      <span>{t('region.openDates.lodging')}</span>
    </Button>
  );
};

export default ToLodgingRedirectButton;
